import { MemberAssessmentStatuses } from '../Assessment/MemberAssessmentStatuses.model';
import { DocumentEngagement } from '../DocumentEngagements/DocumentEngagement.model';

export default interface IMemberAssessmentHistoryDto {
    LastAssessmentCompletedOn: string;
    LastVitalSignCompletedOn: string;
    LastSdohCreatedOn: string;
    ShowSdohAlert: boolean;

    LastSdohCreatedBy: string;
    LastPastPresentHistoryCreatedBy: string;

    LastPastSurgicalHistoryCreatedOn: string;
    LastPastSurgicalHistoryCreatedBy: string;

    LastReviewSystemCreatedBy: string;
    LastPhysicalExamCreatedOn: string;
    LastPhysicalExamCreatedBy: string;

    LastPhqCreatedOn: string;
    LastPhqCreatedBy: string;
    LastPhqScore: number;
    ShowPhqAlert: boolean;

    LastUrinalysisReportCreatedOn: string;
    LastUrinalysisReportCreatedBy: string;

    LastHgbA1CCreatedOn: string;
    LastHgbA1CCreatedBy: string;

    LastDiabetesFootCreatedOn: string;
    LastDiabetesFootCreatedBy: string;

    ShowCarePlanAlert: boolean;
    CurrentHgbA1CCreatedOn: string;
    CurrentHgbA1CCreatedBy: string;
    IsHgbA1CNeedsReview: boolean;
    CurrentUrinalysisReportCreatedOn: string;
    CurrentUrinalysisReportCreatedBy: string;
    IsUrinalysisNeedsReview: boolean;
    LastMiniMentalExamCreatedOn: string;
    LastMiniMentalExamCreatedBy: string;

    LastFactorAndRiskAssessmentCreatedOn: string;
    LastFactorAndRiskAssessmentCreatedBy: string;

    LastSubjectiveAssessmentCreatedOn: string;
    LastSubjectiveAssessmentCreatedBy: string;

    LastLipidCreatedOn: string;
    LastLipidCreatedBy: string;

    CurrentLipidCreatedOn: string;
    CurrentLipidCreatedBy: string;
    IsLipidNeedsReview: boolean;
    LastCounselingCreatedOn: string;
    LastCounselingCreatedBy: string;

    CurrentCounselingCreatedOn: string;
    CurrentCounselingCreatedBy: string;
    ShowConsentFormAlert: boolean;
    LastAdlAssessmentCreatedOn: string;
    LastAdlAssessmentCreatedBy: string;

    LastSexualHealthCreatedOn: string;
    LastSexualHealthCreatedBy: string;

    LastFallRiskCreatedOn: string;
    LastFallRiskCreatedBy: string;

    LastVisionAndHearingCreatedOn: string;
    LastVisionAndHearingCreatedBy: string;

    LastTobaccoAndDrugAssessmentCreatedOn: string;
    LastTobaccoAndDrugAssessmentCreatedBy: string;

    LastPreventativeHealthAdviceCreatedOn: string;
    LastPreventativeHealthAdviceCreatedBy: string;

    LastAdditionalCHPCriteriaCreatedOn: string;
    LastAdditionalCHPCriteriaCreatedBy: string;

    LastScreeningFuhfumCreatedOn: string;
    LastScreeningFuhfumCreatedBy: string;

    LastHamiltonAnxietyCreatedOn: string;
    LastHamiltonAnxietyCreatedBy: string;

    CulturalConsiderationsCreatedOn: string;
    CulturalConsiderationsCreatedBy: string;

    LastBHDiagnosticCreatedOn: string;
    LastBHDiagnosticCreatedBy: string;

    LastCurrentNeedsCreatedOn: string;
    LastCurrentNeedsCreatedBy: string;

    LastMentalHealthTreatmentHistoryCreatedOn: string;
    LastMentalHealthTreatmentHistoryCreatedBy: string;

    LastGAFScaleCreatedOn: string;
    LastGAFScaleCreatedBy: string;

    LastSuicidalHomicidalIdeationCreatedOn: string;
    LastSuicidalHomicidalIdeationCreatedBy: string;

    MemberAssessmentStatuses: MemberAssessmentStatuses;
    EngagementDraft: DocumentEngagement;
}

export class MemberAssessmentHistoryDto implements IMemberAssessmentHistoryDto {
    LastAssessmentCompletedOn: string;
    LastVitalSignCompletedOn: string;
    LastSdohCreatedOn: string;
    ShowSdohAlert: boolean;

    LastSdohCreatedBy: string;
    LastPastPresentHistoryCreatedBy: string;

    LastPastSurgicalHistoryCreatedOn: string;
    LastPastSurgicalHistoryCreatedBy: string;

    LastReviewSystemCreatedBy: string;
    LastPhysicalExamCreatedOn: string;
    LastPhysicalExamCreatedBy: string;

    LastPhqCreatedOn: string;
    LastPhqCreatedBy: string;
    LastPhqScore: number;
    ShowPhqAlert: boolean;

    LastUrinalysisReportCreatedOn: string;
    LastUrinalysisReportCreatedBy: string;

    LastHgbA1CCreatedOn: string;
    LastHgbA1CCreatedBy: string;

    LastDiabetesFootCreatedOn: string;
    LastDiabetesFootCreatedBy: string;

    ShowCarePlanAlert: boolean;
    CurrentHgbA1CCreatedOn: string;
    CurrentHgbA1CCreatedBy: string;
    IsHgbA1CNeedsReview: boolean;
    CurrentUrinalysisReportCreatedOn: string;
    CurrentUrinalysisReportCreatedBy: string;
    IsUrinalysisNeedsReview: boolean;
    LastMiniMentalExamCreatedOn: string;
    LastMiniMentalExamCreatedBy: string;

    LastFactorAndRiskAssessmentCreatedOn: string;
    LastFactorAndRiskAssessmentCreatedBy: string;

    LastSubjectiveAssessmentCreatedOn: string;
    LastSubjectiveAssessmentCreatedBy: string;

    LastLipidCreatedOn: string;
    LastLipidCreatedBy: string;

    CurrentLipidCreatedOn: string;
    CurrentLipidCreatedBy: string;
    IsLipidNeedsReview: boolean;
    LastCounselingCreatedOn: string;
    LastCounselingCreatedBy: string;

    CurrentCounselingCreatedOn: string;
    CurrentCounselingCreatedBy: string;
    ShowConsentFormAlert: boolean;
    LastAdlAssessmentCreatedOn: string;
    LastAdlAssessmentCreatedBy: string;

    LastSexualHealthCreatedOn: string;
    LastSexualHealthCreatedBy: string;

    LastFallRiskCreatedOn: string;
    LastFallRiskCreatedBy: string;

    LastVisionAndHearingCreatedOn: string;
    LastVisionAndHearingCreatedBy: string;

    LastTobaccoAndDrugAssessmentCreatedOn: string;
    LastTobaccoAndDrugAssessmentCreatedBy: string;

    LastPreventativeHealthAdviceCreatedOn: string;
    LastPreventativeHealthAdviceCreatedBy: string;

    LastAdditionalCHPCriteriaCreatedOn: string;
    LastAdditionalCHPCriteriaCreatedBy: string;

    LastScreeningFuhfumCreatedOn: string;
    LastScreeningFuhfumCreatedBy: string;

    LastHamiltonAnxietyCreatedOn: string;
    LastHamiltonAnxietyCreatedBy: string;

    CulturalConsiderationsCreatedOn: string;
    CulturalConsiderationsCreatedBy: string;

    LastBHDiagnosticCreatedOn: string;
    LastBHDiagnosticCreatedBy: string;

    LastCurrentNeedsCreatedOn: string;
    LastCurrentNeedsCreatedBy: string;

    LastMentalHealthTreatmentHistoryCreatedOn: string;
    LastMentalHealthTreatmentHistoryCreatedBy: string;

    LastGAFScaleCreatedOn: string;
    LastGAFScaleCreatedBy: string;

    LastSuicidalHomicidalIdeationCreatedOn: string;
    LastSuicidalHomicidalIdeationCreatedBy: string;

    MemberAssessmentStatuses: MemberAssessmentStatuses;
    EngagementDraft: DocumentEngagement;

    constructor() {
        this.EngagementDraft = new DocumentEngagement();
        this.MemberAssessmentStatuses = new MemberAssessmentStatuses();
    }
}
